import React from 'react';
import PropsTypes from 'prop-types';
import { Button } from 'reactstrap';
import { ENABLED_DETECT_PERMISSION } from 'config';
import { useUser } from 'hooks';

const PermissionButton = (props) => {
  const { permission, tempview } = props;
  const user = useUser();
  if (ENABLED_DETECT_PERMISSION && Array.isArray(permission)) {
    if (
      !user?.userType ||
      user.userType?.indexOf(
        `"method":"${permission?.[0]?.toUpperCase()}","route":"${
          permission?.[1]
        }"`,
      ) === -1
    ) {
      if (tempview) {
        return tempview;
      }
      return null;
    }
  }
  return <Button {...props} />;
};

PermissionButton.prototype = {
  ...Button.propTypes,
  permission: PropsTypes.array,
};

Button.Permission = PermissionButton;
